<layer-header
  (closeLayer)="closeLayer()"
  [listIcons]="false"
  [title]="selectedLaw.id ? 'Edit Law' : 'Add Law'"
>
  <ng-content></ng-content>
</layer-header>
<div class="col-12" *ngIf="selectedLaw">
  <form name="itemForm" role="form">
    <div class="row" style="margin-bottom:1rem">
      <div class="col-md-8 col-sm-12">
        <label class="input-label field-required">{{
          'annexes.docs.name' | translate
        }}</label>
        <input
          class="form-control"
          type="text"
          name="name"
          [(ngModel)]="selectedLaw.name"
          #lawName="ngModel"
          placeholder="{{ 'annexes.doc.name_placeholder' | translate }}"
          [rangeLength]="[2, 256]"
          required
          autofocus
          (input)="isNew(selectedLaw.id) || nameChanged($event.target.value)"
        />
        <p
          class="validation-error"
          *ngIf="lawName?.errors?.required && (lawName?.dirty && lawName?.touched)"
        >
          {{ 'form.validate.required' | translate }}
        </p>
        <p class="validation-error" *ngIf="lawName?.errors?.rangeLength && (lawName?.dirty && lawName?.touched)">
          {{ 'form.validate.minLenght' | translate }} 2!
        </p>
        <p class="validation-error" *ngIf="lawName?.errors?.rangeLength && (lawName?.dirty && lawName?.touched)">
          {{ 'form.validate.maxLenght' | translate }} 256!
        </p>
      </div>
      <div class="col-md-4">
        <label class="input-label">{{
          'annexes.short_name' | translate
        }}</label>
        <input
          class="form-control"
          type="text"
          name="code"
          [(ngModel)]="selectedLaw.shortName"
          #lawShortName="ngModel"
          placeholder="{{ 'annexes.short_name_placeholder' | translate }}"
          [rangeLength]="[2, 20]"
          minlength="2"
          maxlength="20"
          autofocus
        />
        <p class="validation-error" *ngIf="lawShortName?.errors?.rangeLength && (lawShortName?.dirty && lawShortName?.touched)">
          {{ 'form.validate.minLenght' | translate }} 2!
        </p>
        <p class="validation-error" *ngIf="lawShortName?.errors?.rangeLength && (lawShortName?.dirty && lawShortName?.touched)">
          {{ 'form.validate.maxLenght' | translate }} 256!
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="input-label">{{ 'annexes.file' | translate }}</label>
        <div>
          <span *ngIf="selectedLaw.fileId && fileMetadata" class="text-muted">{{
            fileMetadata.filename
          }}</span>
          <i
            *ngIf="selectedLaw.fileId"
            (click)="download(selectedLaw)"
            tooltip="{{ 'annexes.download_file' | translate }}"
            download
            class="fa fa-file list-group-item-v2__edit"
          ></i>
          <label
            *ngIf="isActive"
            class="fa fa-paperclip list-group-item-v2__edit ml-0"
            tooltip="{{ 'annexes.upload_file' | translate }}"
            style="margin-inline-start:1rem;margin-bottom: 0;color:#f78b95;cursor:pointer"
          >
            <file-uploader
              [item]="selectedLaw"
              (fileIdChanged)="handleUpload($event, selectedLaw)"
            ></file-uploader>
          </label>
          <i
            *ngIf="isActive && selectedLaw.fileId"
            tooltip="{{ 'annexes.erase_file' | translate }}"
            class="fa fa-eraser list-group-item-v2__edit services-icon--dangerous"
            [ngClass]="{ active: isActive }"
            (click)="deleteFile(selectedLaw)"
          ></i>
        </div>
      </div>
    </div>
  </form>
  <div class="row" style="margin-bottom:1rem">
    <div class="col-12 mt-4 mb-4">
      <primary-text-button
        (click)="save(selectedLaw)"
        [disabled]="
          isLoading ||
          selectedLaw == null ||
          (selectedLaw.name == null || selectedLaw.name.length == 0)
        "
      >
        {{ 'Save' | translate }}
      </primary-text-button>
      <cancelary-text-button (click)="closeLayer()">
        {{ 'Cancel' | translate }}
      </cancelary-text-button>
    </div>
  </div>
</div>
